var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    style: {
      transform: "scaleX(-1)"
    },
    viewBox: "0 0 8 13",
    fill: "#0078D6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75439 6.73154C7.75439 7.0809 7.60467 7.38034 7.35513 7.57998L1.76545 12.5209C1.36618 12.8702 0.76729 12.8203 0.467842 12.421C0.168395 12.0218 0.168395 11.4728 0.567658 11.1234L5.45863 6.83136C5.50854 6.78145 5.50854 6.73154 5.45863 6.63173L0.56766 2.33965C0.168397 1.99029 0.168397 1.3914 0.517752 1.04204C0.867107 0.692689 1.41609 0.642781 1.81536 0.942228L7.40504 5.8332C7.60467 6.08274 7.75439 6.38219 7.75439 6.73154Z",
    fill: "#5C5C5C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.9fbd1c3081047810a9761a1e9cea9e3a.svg";
export { ForwardRef as ReactComponent };